module.exports = __webpack_public_path__ + "static/emision3-04041d47bf037c1ea3420e12e105c4a0.jpg";